import PaymentManagementHeader from "./PaymentManagementHeader";
import PaymentManagementTable from "./PaymentManagementTable";
import PaymentManagementSummaryCards from "./PaymentManagementSummaryCards";
import PaymentManagementTrendChart from "./PaymentManagementTrendChart";
import PaymentManagementEventsChart from "./PaymentManagementEventsChart";
import PaymentManagementFilters from "./PaymentManagementFilters";

const PaymentManagementPage = () => {
  return (
    <div className="min-h-screen space-y-6 bg-gray-50 p-6">
      <PaymentManagementHeader />

      {/* Main box */}

      <PaymentManagementSummaryCards />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <PaymentManagementTrendChart />
        <PaymentManagementEventsChart />
      </div>

      <PaymentManagementFilters />

      <PaymentManagementTable />
    </div>
  );
};

export default PaymentManagementPage;
